import { useSelector } from "react-redux";

const VehicleInfo = () => {
  const { vehicle } = useSelector((state) => state.data.data);

  return (
    <div className="cy-history-currentInfo">
      <div className="border-lg5 border-b-1 flex px-2 py-2 justify-between">
        <p>Vehicle Number: <span className="text-lb5">{vehicle.vehicleNumber}</span></p>
        <p>Vehicle Reading: <span className="text-lb5">{vehicle.vehicleReading}</span></p>
      </div>
      <div className="flex px-2 py-2 justify-between">
        <p>Driver Name: <span className="text-lb5">{vehicle.driverName}</span></p>
        <p>Driver Phone: <span className="text-lb5">{vehicle.driverMobile}</span></p>
      </div>
    </div>
  );
};

export default VehicleInfo;
